module.exports = __webpack_public_path__ + "img/67_29.b3cc8f9e.png";